import type { TokenViewModel } from "../../../api/axcloud";

export const ACCESS_TOKEN_STORAGE_KEY = "login/ACCESS_TOKEN";

/**
 * セッションストレージからアクセストークンを削除します。
 */
export function clearStoredAccessToken(): void {
  sessionStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
}

/**
 * アクセストークンをセッションストレージに保存します。
 * @param token アクセストークン
 * @returns void
 */
export function persistAccessToken(token: TokenViewModel): void {
  // required2faがtrueのトークンは中間トークンなため、保存しない
  // WHY: required2faがtrueのトークンは2段階認証を完了する前の中間的なトークンであり、
  //      完全な認証が行われていない状態を示すため、セキュリティ上の理由から保存しない
  if (token.required2fa === true || !token.accessToken) {
    clearStoredAccessToken();
    return;
  }

  sessionStorage.setItem(
    ACCESS_TOKEN_STORAGE_KEY,
    JSON.stringify(token)
  );
}

/**
 * セッションストレージからアクセストークンを読み込みます。
 * @returns アクセストークンが存在する場合はTokenViewModelを返し、存在しない場合はnullを返します。
 */
export function readStoredAccessToken(): TokenViewModel | null {
  const item = sessionStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
  if (!item) {
    return null;
  }

  try {
    const token = JSON.parse(item) as TokenViewModel;
    if (token.required2fa === true || !token.accessToken) {
      clearStoredAccessToken();
      return null;
    }
    return token;
  } catch (_error) {
    clearStoredAccessToken();
    return null;
  }
}
